/** Classes base compartilhadas pelos wrappers de input do design system (DS-022). */
export const inputBaseClasses =
  'min-h-11 w-full min-w-0 max-w-full rounded-lg px-3.5 text-sm text-[var(--color-text-primary)] outline-none transition focus:ring-2'

export const inputVariantClasses = {
  default:
    'border border-[var(--color-border)] bg-[var(--color-bg-surface)] focus:border-[var(--color-mint-strong)] focus:ring-[var(--color-mint-ring)]',
  muted:
    'border-0 bg-[var(--color-mint-soft)] focus:ring-[var(--color-mint-ring)] focus:outline-none',
} as const

export type InputVariant = keyof typeof inputVariantClasses

/** TextArea usa padding vertical extra e altura mínima maior. */
export const textareaBaseClasses =
  'min-h-24 w-full min-w-0 max-w-full rounded-lg border border-[var(--color-border)] bg-[var(--color-bg-surface)] px-3.5 py-3 text-sm text-[var(--color-text-primary)] outline-none transition focus:border-[var(--color-mint-strong)] focus:ring-2 focus:ring-[var(--color-mint-ring)]'
